import { render, staticRenderFns } from "./DeliveryNote.vue?vue&type=template&id=e8d09fd6&scoped=true"
import script from "./DeliveryNote.vue?vue&type=script&lang=js"
export * from "./DeliveryNote.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNote.vue?vue&type=style&index=0&id=e8d09fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d09fd6",
  null
  
)

export default component.exports